import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAdminToast } from '../../../../ui/components/AdminToast/AdminToast';
import { AddParticipantStructure, TeamData, ParticipantDataStructure } from '../../../admin/teams/teamsListConfig';
import CampaignService from '../../../../sdk/services/campaignService';
import { initTeamForm } from '../../../admin/teams/edit/[teamId]';
import { UserProfileData } from '../../../profile/Profile';
import {
  LoggerService,
  PAGES,
  removeState,
  trackPage,
  processProfilePictureData,
  base64ToBlob,
  blobToFile,
  processJoinTeamImageData,
  getTranslatedMessage,
  sanitizeOrderNumber,
} from '../../../../ui/utils';
import {
  Button,
  ButtonSize,
  ButtonStyles,
  Input,
  InputValidations,
  MLPVersion,
  PhoneNumber,
  Modal,
  Checkbox,
  Tag,
  TagStyle,
  Theme,
  // Accordion,
  DatePicker,
  RadioButton,
  Tooltip,
  TooltipPreference,
  Toggle,
  FAIcon,
  IconStyle,
  DropDown,
  ButtonTypes,
} from '../../../../ui/components';
import { customEventPropType } from '../../../../ui/components/ImageEditor/types/propsType';
import ImageEditor from '../../../../ui/components/ImageEditor/ImageEditor';
import { useAPICall, useAppSelector } from '../../../../hooks';
import ParticipantService from '../../../../sdk/services/participantService';
import AttachmentService from '../../../../sdk/services/attachmentService';
import TeamService from '../../../../sdk/services/teamService';
import RewardService from '../../../../sdk/services/rewardService';
import VideoEditor from '../../../../ui/components/VideoEditor/VideoEditor';
import MDMSService from '../../../../sdk/services/mdmsService';
import { AttachmentImageBA, DynamicObjectInterface } from '../../../../sdk/type';
import { DropDownData } from '../../../../ui/components/Form/DropDown/types/propsType';
import { countryCodeNumber } from '../../../../__mockData/phoneNumber';
import healthGoalService from '../../../../sdk/services/healthGoalService';
import { CampaignQuestionType, MasterRewardType } from '../../[campaignId]';
import { getTimestamp, isValidEmail } from '../../../../ui/utils/common';
import ValidationService from '../../../../sdk/services/validationService';
import userService from '../../../../sdk/services/userService';
import { getContent } from '../../../../sdk/services/contentService';
import ChangeButton from '../../../../assets/image/icons/change_button.svg';
import RemoveButton from '../../../../assets/image/icons/remove_button.svg';
import personalizeImg from '../../../../assets/image/ProfileImageUpload.svg';
// import { ControlIconType } from '../../../../ui/components/Accordion/Accordion';
import Signature from '../../../../ui/components/Form/Signature/Signature';
import OTPModal from '../../../../ui/components/OTPModal';
import { REACT_APP_COUNTRY } from '../../../../envVars';
import { CampaignData } from '../../../admin/campaign-configuration';
import styles from './index.module.scss';
import { SuccessModal } from './successModal';

export interface OrderData {
  success: boolean;
  errorMessage?: string;
  orderNumber?: string;
  orderName?: string;
  orderAmount?: string;
  message?: string;
  errorCode?: string | number;
}

interface JoinTeamProps {
  decodedData: DynamicObjectInterface;
}

interface HealthGoal {
  title: string;
  key: string;
}

export const JoinTeam = (props: JoinTeamProps) => {
  const { decodedData } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { adminToast } = useAdminToast();
  const apiCall = useAPICall();
  const [searchParams] = useSearchParams();
  const teamId = searchParams.get('tmI');
  const campaignRecId = searchParams.get('cmI');
  const isTeamLeader = searchParams.get('tmL');

  const { userInfo } = useAppSelector(state => state.auth);

  const [teamData, setTeamData] = useState<TeamData>(initTeamForm);
  const [userData, setUserData] = useState<UserProfileData>();
  const [individualData, setIndividualData] = useState<ParticipantDataStructure[]>();
  // const [displayCard, setDisplayCard] = useState(false);
  const [campaignId, setCampaignId] = useState('');
  const [campaignName, setCampaignName] = useState('');
  const [dropdownValue, setDropdownValue] = useState('');
  const [witnessDropdownValue, setWitnessDropdownValue] = useState('');
  const [phoneValue, setPhoneValue] = useState('');
  const [witnessPhoneValue, setWitnessPhoneValue] = useState('');
  const [emailValid, setEmailValid] = useState(true);
  const [phoneLength, setPhoneLength] = useState(false);
  const [witnessPhoneLength, setWitnessPhoneLength] = useState(false);
  const [isConditionMet, setIsConditionMet] = useState(true);
  const [participantInvalid, setParticipantInvalid] = useState(true);
  const [orderNumberValid, setOrderNumberValid] = useState(false);
  const [verificationAttempted, setVerificationAttempted] = useState(false);
  const [verificationAlert, setVerificationAlert] = useState(false);
  const [invalidOrderMessage, setInvalidOrderMessage] = useState<string>('');
  const [videoFile, setVideoFile] = useState<File | null>(null);
  const [selectedOption, setSelectedOption] = useState<'witness' | 'video' | ''>('');
  const [videoPreview, setVideoPreview] = useState<string | null>(null);
  // signature states
  const [participantSignatureImage, setParticipantSignatureImage] = useState<string>('');
  const [participantSignatureCleared, setParticipantSignatureCleared] = useState<boolean>(false);
  const [participantSignatureEmpty, setParticipantSignatureEmpty] = useState<boolean>(true);

  const [witnessSignatureImage, setWitnessSignatureImage] = useState<string>('');
  const [witnessSignatureCleared, setWitnessSignatureCleared] = useState<boolean>(false);
  const [witnessSignatureEmpty, setWitnessSignatureEmpty] = useState<boolean>(true);

  const [showModal, setShowModal] = useState(false);
  const [profileImageUrl, setProfileImageUrl] = useState<string | undefined>('');
  const [profileImageFile, setProfileImageFile] = useState<File | null>(null);
  const [check, setCheck] = useState(false);
  const [campaignData, setCampaignData] = useState<CampaignData>();

  const [showNextForm, setShowNextForm] = useState(false);
  const [showSucessModal, setShowSuccessModal] = useState(false);

  const [addParticipantData, setAddParticipantData] = useState<AddParticipantStructure>({
    campaignId: '',
    userId: 0,
    loginId: userInfo?.loginId ?? '',
    coachId: '',
    enrollmentDate: '',
    directLeaderName: '',
    pin: '',
    orderNumber: '',
    directLeaderId: 0,
    directLeaderPinLevel: 0,
    endDate: '',
    remarks: '',
    witnessName: '',
    witnessContact: '',
    joinedHealthyWarrior: false,
    invisibleParticipant: {
      name: '',
      email: '',
      phone: '',
    },
    isNewAbo: false,
    healthGoals: [],
    rewardCode: '',
  });
  const [orderData, setOrderData] = useState<OrderData>();
  const [requiredEmailOtp, setRequiredEmailOtp] = useState(false);
  const [isOpenVerifyEmailDrawer, setIsOpenVerifyEmailDrawer] = useState(false);
  const [lastVerifiedEmail, setLastVerifiedEmail] = useState<string>();

  const [countdown, setCountdown] = useState<number>(0);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const startCountdown = () => {
    if (countdown > 0) return;
    setCountdown(60);
  };

  useEffect(() => {
    if (countdown > 0) {
      timerRef.current = setTimeout(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
    } else if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [countdown]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userDetailsResponse = await apiCall(userService.getUserDetails, decodedData?.userId);
        // Extract campaignId from the response
        const user = userDetailsResponse?.data?.data;
        setUserData(user);
        setEmailValid(!!user?.email);
        setLastVerifiedEmail(user?.emailVerified ? user?.email : '');
      } catch (error) {
        LoggerService.log('Failed to retrieve user details', error);
      }
    };
    getEmailOtpSettings();
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Call the campaignDetails API to get the campaignId
        const campaignDetailsResponse = await apiCall(CampaignService.getCampaignDetail, `${campaignRecId}`);
        // Extract campaignId from the response
        const campaignIdName = campaignDetailsResponse?.data?.data?.campaignId;
        setCampaignId(campaignIdName);
        setCampaignName(campaignDetailsResponse?.data?.data?.campaignName);
        setCampaignData(campaignDetailsResponse?.data?.data);
        // Now, if campaignId is available, call ParticipantService.getTeamParticipants
        if (campaignIdName && teamId !== 'ind') {
          const response = await apiCall(ParticipantService.getTeamParticipants, {
            campaignId: campaignIdName,
            teamId: teamId,
          });
          setCampaignId(campaignIdName);

          setIndividualData(response?.data?.data ?? []);
        }

        if (
          campaignDetailsResponse?.data?.data?.configJson?.activities?.participant?.rewards?.rewardOptions?.[
            teamId === 'ind' ? 'ind' : 'team'
          ]?.length === 1
        ) {
          handleInputChange(
            'rewardCode',
            campaignDetailsResponse?.data?.data?.configJson?.activities?.participant?.rewards?.rewardOptions?.[
              teamId === 'ind' ? 'ind' : 'team'
            ][0],
          );
        }
      } catch (error) {
        LoggerService.log('Failed to retrieve user details', error);
      }

      // Call selectedUser and trackPage
      const timeout = setTimeout(() => {
        trackPage(PAGES.registerForm);
      }, 1000);

      return () => {
        clearTimeout(timeout);
      };
    };

    fetchData();
  }, [campaignRecId]);

  useEffect(() => {
    (async () => {
      try {
        if (teamId !== 'ind') {
          const response = await apiCall(TeamService.getTeamDetails, `${teamId}`);
          if (response?.data?.status === false || !response?.data?.data) {
            //navigate('/error-page/no-result-found');
          } else {
            const teamData = response?.data?.data ?? initTeamForm;
            setTeamData(teamData);
          }
        }
      } catch (error) {
        LoggerService.log('Failed to retrieve user details', error);
      }
    })();
  }, [teamId]);

  useEffect(() => {
    (async () => {
      if (userInfo?.loginId && campaignData?.configJson) {
        const result = await apiCall(MDMSService.getMDMSUserData, {
          aboNumber: userInfo?.loginId,
          numOfDays: campaignData?.configJson?.activities?.participant?.newAbo?.numOfDays ?? 365,
          campaignStart: campaignData?.campaignStart,
        });
        const mdmsListData = result?.data?.data;
        if (Object.keys(mdmsListData).length > 0) {
          setAddParticipantData(prevValue => ({
            ...prevValue,
            isNewAbo: mdmsListData.isNewAbo,
            pin: mdmsListData.highestPin,
          }));
        }

      if (campaignData?.configJson?.campaignIsHealthGoalSectionShown === 1){
        const payload = {
          campaignId:campaignData.campaignId ,
        };
        const response = await healthGoalService.campaignQuestion(payload);

        const parsedOptions = JSON.parse(response.data.data.options);

        const campaignQuestionData: CampaignQuestionType = {
          ...response.data.data,
          options: parsedOptions,
        };

        setHealthQuestionData(campaignQuestionData);
      } else {
        setHealthQuestionData(null);
      }
      }
    })();
  }, [userInfo?.loginId, campaignData]);


  useEffect(() => {
    const { phone, email } = userData || {};
    if (phone) {
      let [countryCode, number] = phone.split(' ');
      setDropdownValue(countryCode);
      setPhoneValue(number);
      if (number) {
        if (REACT_APP_COUNTRY === 'ID') {
          setPhoneLength(!(number.length > 0 && (number.length < 8 || number.length > 12)));
        } else {
          setPhoneLength(!(number.length > 0 && (number.length < 8 || number.length > 10)));
        }
      } else {
        setPhoneLength(false);
      }
    } 

    if (!email || email === '') {
      setEmailValid(false);
    }
    validateParticipant();
  }, [userData]);

  useEffect(() => {
    if (individualData && teamData.teamId) {
      validateParticipant();
    }
    if (addParticipantData) {
      const { witnessContact } = addParticipantData;
      if (witnessContact) {
        let [countryCode, number] = witnessContact.split(' ');
        setWitnessDropdownValue(countryCode);
        setWitnessPhoneValue(number);

        if (number) {
        if (REACT_APP_COUNTRY === 'ID') {
          setWitnessPhoneLength(!(number.length > 0 && (number.length < 8 || number.length > 12)));
        } else {
          setWitnessPhoneLength(!(number.length > 0 && (number.length < 8 || number.length > 10)));
        }
      } else {
        setWitnessPhoneLength(false);
      }
    }
  }
  }, [addParticipantData, individualData, teamData]);

  const fetchProfileImage = async () => {
    try {
      const response = await AttachmentService.downloadProfileImage(userData?.userId?.toString() ?? '');
      if (response.data && response.data.data && response.data.data.image) {
        setProfileImageUrl(response.data.data.image);
      }
    } catch (error) {
      LoggerService.log('Error downloading image', error);
    }
  };

  useEffect(() => {
    fetchProfileImage();
  }, [decodedData]);

  const getBundleString = () => {
    const allValues =
      campaignData?.activities?.order?.rules?.flatMap(group =>
        group
          .filter(rule => rule.type === 'BUNDLE')
          .flatMap(rule => (Array.isArray(rule.value) ? rule.value : [rule.value])),
      ) ?? [];

    return allValues.filter(Boolean).join(', ');
  };

  const validateParticipant = () => {
    const { orderNumber } = addParticipantData ?? {};
    const { email, phone, emailVerified } = userData ?? {};

    const isAnyFieldEmpty = !orderNumber || !email || !phone || (emailVerified !== 1 && requiredEmailOtp);
    const checkLength = individualData?.filter(participant => participant?.status === 'ACTIVE')?.length ?? 0;
    const isLengthValid = checkLength < Number(teamData?.teamSize) || teamId === 'ind';
    setIsConditionMet(isLengthValid);
    setParticipantInvalid(!isLengthValid || isAnyFieldEmpty || !emailValid || phoneLength);
  };

  const convertSignatureToFile = (base64Signature: string, key: string): File => {
    const blob = base64ToBlob(base64Signature);
    const timestamp = getTimestamp();
    const fileName = `${key}_${timestamp}.png`; // Adjust the file extension if needed
    return blobToFile(blob, fileName);
  };

  const [healthQuestionData, setHealthQuestionData] = useState<CampaignQuestionType | null>(null);
  const [masterRewardData, setMasterRewardData] = useState<MasterRewardType[]>();
  // const getCampaignQuestion = async () => {
  //   try {

  //     if (campaignData?.configJson?.campaignIsHealthGoalSectionShown === 1){

  //       console.log()
  //       const payload = {
  //         campaignId: '',
  //       };
  //       const response = await healthGoalService.campaignQuestion(payload);

  //       const parsedOptions = JSON.parse(response.data.data.options);

  //       const campaignQuestionData: CampaignQuestionType = {
  //         ...response.data.data,
  //         options: parsedOptions,
  //       };

  //       setHealthQuestionData(campaignQuestionData);
  //     } else {
  //       setHealthQuestionData(null);
  //     }
      
  //   } catch (error) {
  //     LoggerService.log('Error retrieving question', error);
  //   }
  // };

  const getMasterReward = async () => {
    try {
      const response = await RewardService.getRewardList();
      setMasterRewardData(response?.data?.data);
    } catch (error) {
      LoggerService.log('Error retrieving question', error);
    }
  };

  useEffect(() => {
    //getCampaignQuestion();
    getMasterReward();
  }, []);

  const [images, setImages] = useState<Record<string, AttachmentImageBA>>({
    userSign: { photoId: 0, url: '', file: null },
    witnessSign: { photoId: 0, url: '', file: null },
    videoSign: { photoId: 0, url: '', file: null },
  });

  const cacheKey = 'emailOtp';
  const getEmailOtpSettings = async () => {
    try {
      const data = await getContent('email_otp', cacheKey, false);

      setRequiredEmailOtp(data);
    } catch (error) {
      LoggerService.log('Failed to retrieve content data. Using default content.');
    }
  };

  const onSave = async () => {
    const checkLength = individualData?.filter(participant => participant?.status === 'ACTIVE')?.length ?? 0;

    let defaultOrder = {
      orderStatus: orderData?.success ? 1 : 0,
      errorMessage: orderData?.errorMessage ?? '',
      orderNumber: orderData?.orderNumber ?? '',
      orderName: orderData?.orderName ?? '',
      orderAmount: orderData?.orderAmount ?? null,
    };

    let combinedRemark = `${addParticipantData?.remarks} ${defaultOrder.errorMessage}`;
    // Convert signatures to files
    // const participantSignatureFile = convertSignatureToFile(participantSignatureImage, 'participant');
    // let witnessSignatureFile: File | null = null; // Explicitly type as File | null
    // if (selectedOption === 'witness') {
    //   witnessSignatureFile = convertSignatureToFile(witnessSignatureImage, 'witness');
    // }

    // // Update the images state
    // setImages((prevImages: Record<string, AttachmentImageBA>) => ({
    //   ...prevImages,
    //   userSign: {
    //     photoId: prevImages.userSign.photoId,
    //     url: URL.createObjectURL(participantSignatureFile), // Create URL for preview
    //     file: participantSignatureFile, // Set the participant signature file
    //   },
    //   witnessSign: witnessSignatureFile
    //     ? {
    //         photoId: prevImages.witnessSign.photoId,
    //         url: URL.createObjectURL(witnessSignatureFile), // Create URL for preview
    //         file: witnessSignatureFile, // Set the witness signature file
    //       }
    //     : prevImages.witnessSign, // Keep the previous value if no witness signature file
    // }));

    const selectedQuestion = healthQuestionData ? healthQuestionData : null;

    const payload = {
      campaignId: campaignId,
      campaignName: campaignName,
      campaignRecId: campaignRecId,
      campaignConsent: check,
      campaignValidity: parseInt(campaignData?.configJson?.activities?.participant?.validity?.value),
      isTeamStart: teamId === 'ind' ? true : checkLength === Number(teamData?.teamSize) - 1,
      teamId: teamId === 'ind' ? teamId : teamData.teamId,
      teamName: teamData.teamName,
      userId: userData?.userId,
      name: userData?.name,
      aboId: userInfo?.loginId,
      coachId: teamData.coachId,
      remarks: combinedRemark,
      invisibleParticipant: {
        name: addParticipantData.invisibleParticipant.name,
        email: addParticipantData.invisibleParticipant.email,
        phone: addParticipantData.invisibleParticipant.phone,
      },
      enrollmentDate: new Date().toISOString().slice(0, -1),
      endDate: new Date().toISOString().slice(0, -1),
      isTeamLeader: isTeamLeader === '1' ? 'true' : 'false',
      isNewAbo: addParticipantData.isNewAbo,
      pin: addParticipantData.pin,
      email: userData?.email,
      phone: userData?.phone,
      orderNumber: addParticipantData?.orderNumber,
      orderAmount: defaultOrder.orderAmount,
      orderName: defaultOrder.orderName,
      orderStatus: defaultOrder.orderStatus,
      gender: userData?.gender,
      race: userData?.race,
      address: userData?.address,
      loaName: userData?.loaName,
      accountType: userData?.accountType,
      highestPinLevel: addParticipantData.pin,
      partyId: userData?.partyId,
      healthGoal: selectedQuestion ? {
        faqId: selectedQuestion?.questionRecId,
        healthQuestionType: selectedQuestion?.questionType,
        healthGoals: addParticipantData.healthGoals,
        isJoinedHealthyWarrior: addParticipantData.joinedHealthyWarrior,
      } : null,
      witnessName: addParticipantData?.witnessName,
      witnessPhone: addParticipantData?.witnessContact,
      rewardCode: addParticipantData?.rewardCode,
      rewardType: 'finalReward',
    };

    const formData = await processJoinTeamImageData(images, JSON.stringify(payload));
    const result = await apiCall(ParticipantService.addParticipant, formData);

    if (!result?.data?.result) {
      if (result.status !== 500) {
        adminToast({
          message: getTranslatedMessage(t, result?.data?.message, result?.data?.messageData),
          theme: Theme.ERROR,
        });
      }
    } else {
      setShowSuccessModal(true);
    }
  };

  const handleInputChange = (name: string, value: string | DynamicObjectInterface) => {
    if (name === 'orderNumber') {
      const strValue = typeof value === 'string' ? value.trim() : '';
      const regex = /^[0-9][0-9,]*$/;

      if (strValue && (strValue.includes(',,') || !regex.test(value))) {
        return;
      }
    }

    // Split the input by commas and trim each part
    const orders = value.split(',').map((order: string) => order.trim());

    // Limit order numbers
    if (orders.length > (campaignData?.activities?.order?.maxOrderNumber ?? 3)) {
      orders.splice(campaignData?.activities?.order?.maxOrderNumber ?? 3);
      value = orders.join(',');
    }
    // Split the name into an array of keys
    const keys = name.split('.');

    setAddParticipantData((prevData: DynamicObjectInterface) => {
      let newData = { ...prevData };

      let currentLevel = newData;
      for (let i = 0; i < keys?.length - 1; i++) {
        if (!currentLevel[keys[i]]) {
          currentLevel[keys[i]] = {};
        }
        currentLevel = currentLevel[keys[i]];
      }

      // Update the value at the nested key
      currentLevel[keys[keys?.length - 1]] = value;

      return newData;
    });

    validateParticipant();
  };

  const handleUserInputChange = (name: string, value: DynamicObjectInterface) => {
    setUserData((prevUserData: DynamicObjectInterface) => ({
      ...prevUserData,
      [name]: value,
    }));
    if (name === 'email') {
      setEmailValid(isValidEmail(value));
    }
  };

  const handleVerifyOrder = async () => {
    setVerificationAttempted(true);
    setVerificationAlert(false);
    const payload = {
      campaignId: campaignData?.campaignId,
      aboId: userInfo?.loginId,
      salesOrderNumber: sanitizeOrderNumber(addParticipantData?.orderNumber),
    };

    if (addParticipantData.orderNumber !== '') {
      try {
        const response = await apiCall(ValidationService.validateOrderNumber, payload);
        const result: OrderData = response.data;
        setOrderData(result);
        if (result.success) {
          setOrderNumberValid(true);
          setInvalidOrderMessage(t('dashboard.api-message.validation-sales-order.success.orderNumberValid'));
        } else {
          setOrderNumberValid(false);
          setInvalidOrderMessage(
            `${t('dashboard.api-message.validation-sales-order.error.orderNumberRequireVerification')} ${
              result?.errorCode
                ? '(' + t('dashboard.api-message.validation-sales-order.error.errorCode') + result.errorCode + ')'
                : ''
            }`,
          );
        }
      } catch (error) {
        LoggerService.log('Error verifying order:', error);
        setOrderNumberValid(false);
        setInvalidOrderMessage(t('dashboard.api-message.validation-sales-order.error.errorOccured'));
      }
    } else {
      setOrderNumberValid(false);
    }
  };

  const handleCloseSuccessModal = async () => {
    setShowSuccessModal(false);
    await removeState(['source', 'team']);
    navigate(`/`);
    window.location.reload();
  };

  //-------------------upload image----------------------------------
  const deleteProfile = async () => {
    const payload = {
      loginId: userData?.userId,
    };
    const deleteProfileResponse = await apiCall(AttachmentService.removeProfile, payload);

    if (deleteProfileResponse.status === 200) {
      setProfileImageUrl('');
    }
  };

  const handleFileImage = (e: customEventPropType, view: string) => {
    const file = e.files[0];
    setProfileImageFile(file);
    const objectUrl = URL.createObjectURL(file);
    setProfileImageUrl(objectUrl);
    setShowModal(false);
  };

  const handleFile = (e: ChangeEvent<HTMLInputElement>, key: string) => {
    const file = e.target.files?.[0] as File | null;

    setProfileImageFile(file);
    if (file) {
      const objectUrl = URL.createObjectURL(file);
      setProfileImageUrl(objectUrl);
    } else {
      setProfileImageUrl('');
    }
    setShowModal(false);
  };

  const handleOptionChange = (option: 'witness' | 'video') => {
    if (option === 'witness') {
      clearVideo();
    } else if (option === 'video') {
      clearWitnessSignature();
      handleInputChange('witnessName', '');
      handleInputChange('witnessContact', '');
      setWitnessPhoneValue('');
    }
    setSelectedOption(option);
  };

  const handleVideoUpload = (event: customEventPropType) => {
    const file = event.files[0];
    if (file) {
      const maxFileSizeMB = 50;
      const fileSizeMB = file.size / (1024 * 1024);

      if (fileSizeMB > maxFileSizeMB) {
        // Show a message or handle the error
        adminToast({
          message: t('dashboard.join-team.register.message.fileSizeExceeeds').replace(
            '{file-size}',
            fileSizeMB.toFixed(2),
          ),
          theme: Theme.ERROR,
        });
        return;
      }

      const currentDate = new Date();
      const timestamp = currentDate.toISOString().replace(/[:.-]/g, '');
      const newFileName = `video_${timestamp}.mp4`;

      // Create a new File object with the new name
      const newFile = new File([file], newFileName, { type: file.type });

      // Update state with the new file
      setVideoFile(newFile);
      setImages((prevImages: Record<string, AttachmentImageBA>) => ({
        ...prevImages,
        [`videoSign`]: {
          photoId: prevImages[`videoSign`].photoId,
          url: URL.createObjectURL(newFile),
          file: new File([file], newFileName),
        },
      }));

      // Generate a URL for the video preview
      const videoURL = URL.createObjectURL(newFile);
      setVideoPreview(videoURL);
    }
  };

  const clearVideo = () => {
    // Revoke the old video URL to free up memory
    if (videoPreview) {
      URL.revokeObjectURL(videoPreview);
    }

    // Clear the state
    setVideoFile(null);
    setVideoPreview(null);
  };

  useEffect(() => {
    if (profileImageFile !== null) {
      handleFileUpload();
    }
  }, [profileImageFile]);

  const handleFileUpload = async () => {
    try {
      if (profileImageFile && String(userData?.userId)) {
        const formData = processProfilePictureData(profileImageFile, String(userData?.userId));
        const response = await apiCall(() => AttachmentService.postUploadProfile(formData));

        if (response.status === 200) {
          LoggerService.log('Successfully upload image', response);
        }
      }
    } catch (error) {
      LoggerService.log('Error upload image', error);
    }
  };

  const uploadImageModal = (
    <>
      {showModal && (
        <Modal
          primaryButtonLabel={''}
          headline={t('dashboard.join-team.register.modal.uploadProfilePicture')}
          containerWidth={'570px'}
          containerHeight={'570px'}
          closeIcon={true}
          onClose={() => setShowModal(false)}
        >
          <div>
            {profileImageUrl ? (
              <div className={styles['profile-image-container']}>
                <div className={styles['image-wrapper']}>
                  <img
                    src={profileImageUrl}
                    alt={t('dashboard.join-team.register.modal.beforeFrontViewAlt')}
                    className={styles['profile-image']}
                    // style={{ borderRadius: '50%' }}
                  />
                </div>
                <div className={styles['buttons-container']}>
                  <button
                    className={styles['change-photo']}
                    onClick={() => document.getElementById('profileImageUrl')?.click()}
                  >
                    <img src={ChangeButton} alt="bg" />
                    <input
                      type="file"
                      id="profileImageUrl"
                      accept="image/*"
                      onChange={e => handleFile(e, 'profileImageUrl')}
                      style={{ display: 'none' }}
                    />
                  </button>
                  <button className={styles['remove-photo']} onClick={() => deleteProfile()}>
                    <img src={RemoveButton} alt="bg" />
                  </button>
                </div>
              </div>
            ) : (
              <ImageEditor onFileUpload={e => handleFileImage(e, 'file')} accept="image/*" />
            )}
          </div>
        </Modal>
      )}
    </>
  );

  const showModalFn = () => {
    setShowModal(true);
  };

  const saveParticipantSignature = (imageData: string) => {
    setParticipantSignatureImage(imageData);
    const participantSignatureFile = convertSignatureToFile(imageData, 'participant');
    setImages((prevImages: Record<string, AttachmentImageBA>) => ({
      ...prevImages,
      userSign: {
        photoId: prevImages.userSign.photoId,
        url: URL.createObjectURL(participantSignatureFile), // Create URL for preview
        file: participantSignatureFile, // Set the participant signature file
      },
    }));
  };

  const clearParticipantSignature = () => {
    setParticipantSignatureCleared(prev => !prev);
    setParticipantSignatureEmpty(true);
    setParticipantSignatureImage('');
  };

  const saveWitnessSignature = (imageData: string) => {
    setWitnessSignatureImage(imageData);
    const witnessSignatureFile = convertSignatureToFile(imageData, 'witness');
    setImages((prevImages: Record<string, AttachmentImageBA>) => ({
      ...prevImages,
      witnessSign: {
        photoId: prevImages.witnessSign.photoId,
        url: URL.createObjectURL(witnessSignatureFile), // Create URL for preview
        file: witnessSignatureFile, // Set the witness signature file
      },
    }));
  };

  const clearWitnessSignature = () => {
    setWitnessSignatureCleared(prev => !prev);
    setWitnessSignatureEmpty(true);
    setWitnessSignatureImage('');
    setWitnessDropdownValue('');
  };

  const healthGoals: HealthGoal[] = healthQuestionData?.options ?? [{ title: '', key: '' }];
  const handleCheckboxChange = (goalKey: string, isChecked: boolean) => {
    // Update the healthGoals array based on the checkbox state
    setAddParticipantData(prevData => {
      // Check if the checkbox is checked or unchecked
      const updatedHealthGoals = isChecked
        ? [...prevData.healthGoals, healthGoals.find(goal => goal.key === goalKey)!]
        : prevData.healthGoals.filter(goal => goal.key !== goalKey);

      return {
        ...prevData,
        healthGoals: updatedHealthGoals,
      };
    });
  };

  const rewardOptions =
    campaignData?.configJson?.activities?.participant?.rewards?.rewardOptions?.[teamId === 'ind' ? 'ind' : 'team'] ||
    [];

  const allRewardsNoImage = rewardOptions.every((rewardCode: string) => {
    const matchedReward = masterRewardData?.find((r: DynamicObjectInterface) => r.rewardCode === rewardCode);
    return !matchedReward?.imageURL;
  });

  const rewardSelectionForm = allRewardsNoImage ? (
    <DropDown
      name="rewardCode"
      dropdownLabel={``}
      disabledFilter={false}
      mlpVersion={MLPVersion.ONE}
      placeholder={t('dashboard.join-team.register.label.rewardSelection')}
      value={
        masterRewardData?.find((r: DynamicObjectInterface) => r.rewardCode === addParticipantData.rewardCode)
          ?.rewardName
      }
      data={masterRewardData?.filter((r: DynamicObjectInterface) => rewardOptions.includes(r.rewardCode))}
      configData={{
        label: 'rewardName',
        onSelect: (selectedItem: DynamicObjectInterface) => {
          handleInputChange('rewardCode', selectedItem?.rewardCode);
        },
      }}
      readOnly={false}
      disabled={!isConditionMet}
    />
  ) : (
    <>
      {rewardOptions.map((rewardCode: string) => {
        const { rewardName, imageURL } =
          masterRewardData?.find((r: DynamicObjectInterface) => r.rewardCode === rewardCode) ?? {};
        return (
          <div className={styles['radio-container-box']} key={rewardCode}>
            <RadioButton
              label={rewardName}
              checked={addParticipantData?.rewardCode === rewardCode}
              onChange={() => {
                handleInputChange('rewardCode', rewardCode);
              }}
              disabled={!isConditionMet}
            />
            {imageURL ? (
              <img className={styles['radio-container-img']} src={imageURL} alt="reward" />
            ) : (
              <div className={styles['radio-container-img']}>
                <FAIcon
                  iconStyle={IconStyle.SOLID}
                  iconName="gift"
                  theme={Theme.BLACK}
                  className={styles['radio-container-icon']}
                />
              </div>
            )}
          </div>
        );
      })}
    </>
  );

  const handleRequestOTP = async (mode?: string) => {
    if (mode === 'new') {
      setIsOpenVerifyEmailDrawer(true);
    }

    if (countdown <= 0) {
      const payload = {
        email: userData?.email,
        country: REACT_APP_COUNTRY?.toLowerCase(),
        channel: 'email',
      };

      const res = await apiCall(userService.requestOTP, payload);
      if (res.result) {
        startCountdown();
        adminToast({
          message: 'A one-time password (OTP) has been sent to your email address.',
          theme: Theme.SUCCESS,
        });
        return true;
      }
    }
    return false;
  };

  const handleVerifyEmail = async (otpCode: string) => {
    //call verify email
    const payload = {
      otpCode: otpCode,
      email: userData?.email,
      country: REACT_APP_COUNTRY?.toLowerCase(),
    };

    const res = await apiCall(userService.verifyOTP, payload);

    if (res.result && res.data?.isValid === true) {
      handleUserInputChange('emailVerified', 1);
      setIsOpenVerifyEmailDrawer(false);
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className={styles['join-team-container']}>
      <div className={styles['card']}>
        <div className={styles['card-header']}>
          <h2>{t('dashboard.join-team.register.label.title')}</h2>
        </div>
        {!isConditionMet ? (
          <Tag
            text={t('dashboard.join-team.register.label.teamParticipantLimitError')}
            theme={Theme.ERROR}
            style={TagStyle.OUTLINE}
          />
        ) : null}
        <div className={styles['participant-container']}>
          {!showNextForm ? (
            <>
              <div className={styles['add-participant-form-container-three-column']}>
                <div className={`${styles['card-user-img']}`}>
                  <div className={styles['img-container']}>
                    <img
                      src={profileImageUrl ? profileImageUrl : personalizeImg}
                      alt="personalize"
                      onClick={showModalFn}
                      className={styles['main-profile-image']}
                    />
                  </div>
                </div>
                <div></div>
                <div></div>
                <div className={styles['input-container']}>
                  <div className={styles['pin-dropdown']}>
                    <Input
                      name={'campaignName'}
                      placeholder={t('dashboard.join-team.register.input.placeholder.campaignTitle')}
                      value={campaignName}
                      disabled
                      mlpVersion={MLPVersion.ONE}
                      label={t('dashboard.join-team.register.input.campaignTitle')}
                    />
                  </div>
                </div>

                {teamId !== 'ind' && (
                  <div className={styles['input-container']}>
                    <div className={styles['team-name-section']}>
                      <Input
                        name={'teamName'}
                        placeholder={t('dashboard.join-team.register.input.placeholder.teamName')}
                        value={teamData.teamName}
                        disabled
                        mlpVersion={MLPVersion.ONE}
                        label={t('dashboard.join-team.register.input.teamName')}
                      />
                    </div>
                  </div>
                )}
              </div>
              <hr className={styles['horizontal-line']} />
              <div className={styles['add-participant-form-container-three-column']}>
                <div>
                  <Input
                    name={'aboId'}
                    placeholder={t('dashboard.join-team.register.input.placeholder.aboId')}
                    value={userInfo?.loginId ?? ''}
                    disabled
                    mlpVersion={MLPVersion.ONE}
                    label={t('dashboard.join-team.register.input.aboId')}
                  />
                </div>
                <div className={styles['participant-section']}>
                  <Input
                    label={t('dashboard.join-team.register.input.participantName')}
                    name="name"
                    placeholder={t('dashboard.join-team.register.input.placeholder.participantName')}
                    mlpVersion={MLPVersion.ONE}
                    value={userData?.name}
                    required={true}
                    disabled
                  />
                </div>
                <div></div>
                <div className={styles['participant-section']}>
                  <div className={styles['label-text-phone']}>
                    {t('dashboard.join-team.register.input.participantPhoneNumber')}{' '}
                    <span className={styles['label-red']}>*</span>
                  </div>
                  <PhoneNumber
                    name={'phoneNumber'}
                    data={countryCodeNumber}
                    inputValue={phoneValue}
                    dropdownValue={dropdownValue}
                    required={true}
                    placeholder={t('dashboard.join-team.register.input.placeholder.participantPhoneNumber')}
                    disabled={!isConditionMet}
                    dropdownDisabled={!isConditionMet}
                    status={
                      phoneValue.length === 0
                        ? InputValidations.INVALID
                        : !phoneLength
                          ? InputValidations.INVALID
                          : InputValidations.DEFAULT
                    }
                    message={
                      phoneValue.length === 0
                        ? t('dashboard.join-team.register.input.message.phoneNumberIsRequired')
                        : !phoneLength
                          ? t('dashboard.join-team.register.input.message.invalidPhoneNumber')
                          : ''
                    }
                    configData={{
                      label: 'name',
                      onSelect: (e: DropDownData) => {
                        setDropdownValue(e.name as string);
                        // Check if selectedOption is not empty before setting phoneValue
                        if (e.name) {
                          let _phoneValue = phoneValue;

                          // Remove leading 0 if country code exists
                          if (phoneValue?.startsWith('0')) {
                            _phoneValue = phoneValue.slice(1);
                          }

                          const combinedValue = `${e.name} ${_phoneValue}`;
                          setPhoneValue(_phoneValue === '' ? '' : _phoneValue); // Ensure phoneValue is not set if it's already empty
                          handleUserInputChange('phone', combinedValue);
                        } else {
                          setPhoneValue(''); // Reset phoneValue to empty if dropdownValue is not selected
                          handleUserInputChange('phone', ''); // Update the state accordingly
                        }
                      },
                    }}
                    onInputChange={val => {
                      let phoneNumber = val ?? '';

                      // Remove leading 0 if country code exists
                      if (!!dropdownValue && phoneNumber?.startsWith('0')) {
                        phoneNumber = phoneNumber.slice(1);
                      }

                      setPhoneValue(phoneNumber);

                      if (phoneNumber) {
                        const combinedValue = `${dropdownValue} ${phoneNumber}`;
                        setPhoneValue(phoneNumber === '' ? '' : phoneNumber);
                        handleUserInputChange('phone', combinedValue);

                        if (REACT_APP_COUNTRY === 'ID') {
                          setPhoneLength(
                            !(phoneNumber.length > 0 && (phoneNumber.length < 8 || phoneNumber.length > 12)),
                          );
                        } else {
                          setPhoneLength(
                            !(phoneNumber.length > 0 && (phoneNumber.length < 8 || phoneNumber.length > 10)),
                          );
                        }
                      } else {
                        setPhoneValue(''); // Reset phoneValue to empty if dropdownValue is not selected
                        handleUserInputChange('phone', ''); // Update the state accordingly
                      }
                    }}
                    maxLength={REACT_APP_COUNTRY === 'ID' ? 12 : 10}
                  />
                </div>
                <div className={styles['participant-section']}>
                  <Input
                    name="email"
                    label={t('dashboard.join-team.register.input.participantEmail')}
                    value={userData?.email}
                    mlpVersion={MLPVersion.ONE}
                    onChange={e => {
                      const value = e.target.value;
                      handleUserInputChange('email', value);
                      handleUserInputChange('emailVerified', value === lastVerifiedEmail ? 1 : 0);
                    }}
                    disabled={!isConditionMet}
                    status={
                      userData?.email === '' || !emailValid
                        ? InputValidations.INVALID
                        : userData?.emailVerified === 1 && requiredEmailOtp
                          ? InputValidations.VALID
                          : requiredEmailOtp
                            ? InputValidations.WARNING
                            : InputValidations.DEFAULT
                    }
                    message={
                      userData?.email === ''
                        ? t('dashboard.profile.message.requiredEmail')
                        : userData?.emailVerified === 1 && requiredEmailOtp
                          ? t('dashboard.profile.message.emailVerified')
                          : emailValid && requiredEmailOtp
                            ? t('dashboard.join-team.register.input.message.clickVerifyEmail')
                            : emailValid
                              ? ''
                              : t('dashboard.profile.message.invalidEmailFormat')
                    }
                  />
                </div>
                {requiredEmailOtp && userData?.emailVerified !== 1 ? (
                  <Button
                    className={styles['verify-order']}
                    title={t('dashboard.profile.button.verifyEmail')}
                    type={ButtonTypes.BUTTON}
                    onClick={() => handleRequestOTP('new')}
                    buttonStyle={ButtonStyles.SOLID}
                    size={ButtonSize.SMALL}
                    theme={Theme.GREEN}
                    data-testid="primary-button-test-id"
                    disabled={userData?.email === '' || !emailValid || !isConditionMet}
                  />
                ) : (
                  <div></div>
                )}

                <div className={styles['participant-section']}>
                  <Input
                    name="orderNumber"
                    label={t('dashboard.join-team.register.input.orderNumber')}
                    value={addParticipantData?.orderNumber}
                    required={true}
                    mlpVersion={MLPVersion.ONE}
                    onChange={e => {
                      handleInputChange('orderNumber', e.target.value.toString());
                      if (verificationAttempted) setVerificationAttempted(false);
                    }}
                    disabled={!isConditionMet}
                    message={
                      addParticipantData?.orderNumber !== ''
                        ? verificationAttempted
                          ? orderNumberValid
                            ? t('dashboard.join-team.register.input.message.validOrderNumber')
                            : invalidOrderMessage
                          : verificationAlert
                            ? `*${t('dashboard.join-team.register.input.message.clickVerifyOrderToContinue')}`
                            : getBundleString()
                              ? `*${t('dashboard.join-team.register.input.message.orderWithPurchaseBundleSKU').replace(
                                  '{bundle-sku}',
                                  getBundleString(),
                                )}`
                              : ''
                        : getBundleString()
                          ? `*${t('dashboard.join-team.register.input.message.orderWithPurchaseBundleSKU').replace(
                              '{bundle-sku}',
                              getBundleString(),
                            )}`
                          : ''
                    }
                    status={
                      addParticipantData?.orderNumber !== ''
                        ? verificationAttempted
                          ? orderNumberValid
                            ? InputValidations.VALID
                            : InputValidations.WARNING
                          : verificationAlert
                            ? InputValidations.INVALID
                            : InputValidations.DEFAULT
                        : InputValidations.DEFAULT
                    }
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        handleVerifyOrder();
                      }
                    }}
                    onBlur={() => {
                      addParticipantData?.orderNumber !== '' && !verificationAttempted && setVerificationAlert(true);
                    }}
                  />
                </div>
                <Button
                  className={styles['verify-order']}
                  size={ButtonSize.SMALL}
                  buttonStyle={ButtonStyles.SOLID}
                  theme={Theme.GREEN}
                  title={t('dashboard.join-team.register.button.verifyOrder')}
                  disabled={addParticipantData?.orderNumber === ''}
                  onClick={handleVerifyOrder}
                />
              </div>
              <div className={styles['mobile-gap']} />

              {/* <Accordion
            key={'HealthGoal'}
            id={'HealthGoal'}
            iconType={ControlIconType.CHEVRON}
            title={t('Health Goal')}
            required
            //theme={Theme.GREEN}
            childrenTitle={
              <div className={styles['margin-left-auto']}>
                {addParticipantData.healthGoals.length === 0 && (
                  <Tag theme={Theme.ERROR} style={TagStyle.OUTLINE} text={'Incomplete'} />
                )}
              </div>
            }
          > */}

              {campaignData && !!campaignData?.configJson?.campaignIsHealthGoalSectionShown && (
                <>
                  <hr className={styles['horizontal-line']} />

                  <div className={styles['health-goal-container']}>
                    <div className={styles['health-goal-title']}>
                      {t('dashboard.join-team.register.label.healthGoal')}
                      <span className={styles['label-red']}> *</span>
                    </div>
                    <div className={styles['health-goal-subtitle']}>
                      {t('dashboard.join-team.register.label.tickMoreThanOne')}
                    </div>
                    <div className={styles['checkbox-container']}>
                      {healthGoals.map(goal => (
                        <div className={styles['checkbox-container-box']} key={goal.key}>
                          <input
                            id={goal.key}
                            className={styles['checkbox-container-checkbox']}
                            type="checkbox"
                            checked={addParticipantData?.healthGoals?.some(g => g.key === goal.key)}
                            onChange={e => handleCheckboxChange(goal.key, e.target.checked)}
                            disabled={!isConditionMet}
                          />
                          <label className={styles['checkbox-container-label']} htmlFor={goal.key}>
                            {goal.title}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className={styles['health-warrior-container']}>
                    <div className={styles['health-warrior-subtitle']}>{`${t(
                      'dashboard.join-team.register.label.joinedHealthWarrior',
                    )}?`}</div>
                    <div className={styles['health-warrior-toggle']}>
                      <Toggle
                        onChange={(e: DynamicObjectInterface) => {
                          handleInputChange('joinedHealthyWarrior', e.target.checked.toString());
                        }}
                        disabled={!isConditionMet}
                      />
                    </div>
                    <div className={styles['health-warrior-subtitle-subtext']}>
                      {addParticipantData?.joinedHealthyWarrior?.toString() === 'true'
                        ? t('dashboard.join-team.register.label.yes')
                        : t('dashboard.join-team.register.label.no')}
                    </div>
                  </div>
                </>
              )}

              {campaignData?.configJson?.activities?.participant?.rewards?.showRewardSelectionForm === 1 && (
                <>
                  <hr className={styles['horizontal-line']} />
                  <div className={styles['health-goal-container']}>
                    <div className={styles['health-goal-title']}>
                      {t('dashboard.join-team.register.label.rewardSelection')}
                      <span className={styles['label-red']}> *</span>
                    </div>
                    <div className={styles['health-goal-subtitle']}>
                      {t('dashboard.join-team.register.label.rewardSelectionDesc')}
                    </div>
                    <div className={styles['radio-container']}>{rewardSelectionForm}</div>
                    <div className={styles['input-message-footnote']}>
                      *{t('dashboard.join-team.register.label.rewardAvailabilityNote')}
                    </div>
                  </div>
                </>
              )}

              {/* </Accordion> */}

              <div className={styles['security-privacy-checkbox-container']}>
                <Checkbox
                  text={
                    <p
                      id="agree-checkbox"
                      dangerouslySetInnerHTML={{
                        __html: t('dashboard.join-team.register.label.agreementCampaign').replace(
                          '{terms-conditions}',
                          `<a href="/terms-and-conditions?cid=${campaignId}" target="_blank">${t(
                            'dashboard.join-team.register.label.termsConditions',
                          )}</a>`,
                        ),
                      }}
                    />
                  }
                  onChange={() => setCheck(prevValue => !prevValue)}
                  checked={check}
                  className={styles['security-privacy-checkbox']}
                  disabled={!isConditionMet}
                />
              </div>

              <div className={styles['participant-register-button']}>
                {/* For ID, user signature, witness signature, video upload verification are not required, skip next form/page */}
                {REACT_APP_COUNTRY === 'MY' ? (
                  <Button
                    title={t('dashboard.join-team.register.button.continue')}
                    buttonStyle={ButtonStyles.SOLID}
                    theme={Theme.GREEN}
                    disabled={
                      !(
                        (
                          check && // Must be checked
                          addParticipantData?.orderNumber && // Order number should not be empty
                          (campaignData?.configJson?.campaignIsHealthGoalSectionShown !== 1 || addParticipantData?.healthGoals?.length > 0) && // At least one health goal must be selected
                          verificationAttempted &&
                          (campaignData?.configJson?.activities?.participant?.rewards?.showRewardSelectionForm !== 1 ||
                            addParticipantData?.rewardCode) &&
                          (userData?.emailVerified === 1 || !requiredEmailOtp)
                        ) // must click verify order button
                      )
                    }
                    onClick={() => setShowNextForm(true)}
                  />
                ) : (
                  <Button
                    title={t('dashboard.join-team.register.button.register')}
                    buttonStyle={ButtonStyles.SOLID}
                    theme={Theme.GREEN}
                    disabled={
                      !(
                        (
                          check && // Must be checked
                          addParticipantData?.orderNumber &&
                          (campaignData?.configJson?.campaignIsHealthGoalSectionShown !== 1 ||
                            addParticipantData?.healthGoals?.length > 0) && // At least one health goal must be selected if health section shown
                          verificationAttempted && // order verification attempted
                          (campaignData?.configJson?.activities?.participant?.rewards?.showRewardSelectionForm !== 1 ||
                            addParticipantData?.rewardCode) &&
                          (userData?.emailVerified === 1 || !requiredEmailOtp)
                        ) // Order number should not be empty
                      )
                    }
                    onClick={onSave}
                  />
                )}
              </div>
            </>
          ) : (
            <>
              {/* <Accordion
                key={'ParticipantSignature'}
                id={'ParticipantSignature'}
                iconType={ControlIconType.CHEVRON}
                title={t('Participant Signature')}
                required
                childrenTitle={
                  <div className={styles['margin-left-auto']}>
                    {!participantSignatureImage ? (
                      <Tag theme={Theme.ERROR} style={TagStyle.OUTLINE} text={'Incomplete'} />
                    ) : (
                      <></>
                    )}
                  </div>
                }
              > */}
              <div className={styles['participant-signature']}>
                <div className={styles['participant-signature-subtitle']}>
                  {t('dashboard.join-team.register.label.pleaseSignAgreement')}
                </div>
                <div className={styles['participant-signature-label-container']}>
                  <div className={styles['participant-signature-your-signature']}>
                    {t('dashboard.join-team.register.label.yourSignature')}
                  </div>
                  <span className={styles['label-red']}>*</span>
                </div>
                <div className={styles['participant-signature-container']}>
                  <div>
                    <Signature
                      callback={saveParticipantSignature}
                      // completed={participantSignatureDone}
                      cleared={participantSignatureCleared}
                      className={styles['participant-signature-signature']}
                      isTouched={() => setParticipantSignatureEmpty(false)}
                      signatureData={participantSignatureImage}
                    />
                    <div className={styles['participant-signature-button-container']}>
                      <button className={styles['clear-button']} onClick={clearParticipantSignature}>
                        {t('dashboard.join-team.register.button.clear')}
                      </button>
                    </div>
                  </div>
                  <div className={styles['participant-signature-icon-container']}>
                    {participantSignatureImage ? (
                      <FAIcon iconName="check" theme={Theme.SUCCESS} iconStyle={IconStyle.SOLID} />
                    ) : (
                      <FAIcon iconName="x" theme={Theme.ERROR} iconStyle={IconStyle.SOLID} />
                    )}
                  </div>
                  <div className={styles['participant-signature-date-container']}>
                    <div className={styles['participant-signature-date-label-container']}>
                      <div className={styles['participant-signature-label']}>
                        {t('dashboard.join-team.register.input.date')} <span className={styles['label-red']}>*</span>
                      </div>
                    </div>
                    <div className={styles['participant-signature-date-date-container']}>
                      <DatePicker disabled value={new Date()} />
                    </div>
                  </div>
                </div>
              </div>
              {/* </Accordion> */}

              {/* <Accordion
                key={'WitnessSignature'}
                id={'WitnessSignature'}
                iconType={ControlIconType.CHEVRON}
                title={t('Witness/Video Verification')}
                required
                childrenTitle={
                  <div className={styles['margin-left-auto']}>
                    {!selectedOption ? (
                      <Tag theme={Theme.ERROR} style={TagStyle.OUTLINE} text={'Incomplete'} />
                    ) : selectedOption === 'witness' &&
                      (!witnessSignatureImage ||
                        !addParticipantData?.witnessName ||
                        !addParticipantData?.witnessContact) ? (
                      <Tag theme={Theme.ERROR} style={TagStyle.OUTLINE} text={'Incomplete'} />
                    ) : selectedOption === 'video' && !videoPreview ? (
                      <Tag theme={Theme.ERROR} style={TagStyle.OUTLINE} text={'Incomplete'} />
                    ) : (
                      <></>
                    )}
                  </div>
                }
              > */}

              <hr className={styles['horizontal-line']} />
              <div className={styles['witness-title']}>
                {t('Witness/Video Verification')}
                <span className={styles['label-red']}>*</span>
              </div>
              <div className={styles['witness']}>
                <div
                  dangerouslySetInnerHTML={{ __html: t('dashboard.join-team.register.label.chooseOneOfTheOptions') }}
                ></div>
                <div className={styles['witness-signature-container']}>
                  <div className={styles['witness-signature-radio']}>
                    <RadioButton
                      label={'Witness Signature'}
                      checked={selectedOption === 'witness'}
                      onChange={() => handleOptionChange('witness')}
                    />
                  </div>
                  {selectedOption === 'witness' && (
                    <div className={styles['witness-signature-section']}>
                      <div className={styles['witness-signature-signature']}>
                        <Signature
                          callback={saveWitnessSignature}
                          // completed={witnessSignatureDone}
                          className={styles['participant-signature-signature']}
                          cleared={witnessSignatureCleared}
                          isTouched={() => setWitnessSignatureEmpty(false)}
                          signatureData={witnessSignatureImage}
                        />
                        <div className={styles['witness-signature-button-container']}>
                          <button className={styles['clear-button']} onClick={clearWitnessSignature}>
                            {t('dashboard.join-team.register.button.clear')}
                          </button>
                        </div>
                      </div>
                      <div className={styles['witness-signature-icon-container']}>
                        {witnessSignatureImage ? (
                          <FAIcon iconName="check" theme={Theme.SUCCESS} iconStyle={IconStyle.SOLID} />
                        ) : (
                          <FAIcon iconName="x" theme={Theme.ERROR} iconStyle={IconStyle.SOLID} />
                        )}
                      </div>
                      <div className={styles['witness-signature-data']}>
                        <div className={styles['witness-signature-data-container']}>
                          <div className={styles['participant-signature-label']}>
                            {t('dashboard.join-team.register.label.witnessName')}{' '}
                            <span className={styles['label-red']}>*</span>
                          </div>
                          <div className={styles['participant-signature-date-date-container']}>
                            <Input
                              label=""
                              name="witnessName"
                              placeholder={t('dashboard.join-team.register.input.witnessName')}
                              mlpVersion={MLPVersion.ONE}
                              value={addParticipantData.witnessName}
                              onChange={e => {
                                handleInputChange('witnessName', e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className={styles['witness-signature-data-container']}>
                          <div className={styles['participant-signature-label']}>
                            {t('dashboard.join-team.register.label.witnessContactNumber')}{' '}
                            <span className={styles['label-red']}>*</span>
                          </div>
                          <div className={styles['participant-signature-date-date-container']}>
                            <PhoneNumber
                              name={'witnessPhoneNumber'}
                              data={countryCodeNumber}
                              inputValue={witnessPhoneValue}
                              dropdownValue={witnessDropdownValue}
                              placeholder={t('dashboard.join-team.register.input.placeholder.witnessPhoneNumber')}
                              status={
                                witnessPhoneValue.length === 0
                                ? InputValidations.INVALID
                                : !witnessPhoneLength
                                  ? InputValidations.INVALID
                                  : InputValidations.DEFAULT
                              }
                              message={
                                witnessPhoneValue.length === 0
                                  ? t('dashboard.join-team.register.input.message.phoneNumberIsRequired')
                                  : !witnessPhoneLength
                                    ? t('dashboard.join-team.register.input.message.invalidPhoneNumber')
                                    : ''
                              }
                              configData={{
                                label: 'name',
                                onSelect: (e: DropDownData) => {
                                  setWitnessDropdownValue(e.name as string);
                                  // Check if selectedOption is not empty before setting phoneValue
                                  if (e.name) {
                                    let _phoneValue = witnessPhoneValue;

                                    // Remove leading 0 if country code exists
                                    if (witnessPhoneValue?.startsWith('0')) {
                                      _phoneValue = witnessPhoneValue.slice(1);
                                    }

                                    const combinedValue = `${e.name} ${_phoneValue}`;
                                    setWitnessPhoneValue(_phoneValue === '' ? '' : _phoneValue); // Ensure phoneValue is not set if it's already empty
                                    handleUserInputChange('witnessContact', combinedValue);
                                  } else {
                                    setWitnessPhoneValue(''); // Reset phoneValue to empty if dropdownValue is not selected
                                    handleUserInputChange('witnessContact', ''); // Update the state accordingly
                                  }
                                },
                              }}
                              onInputChange={val => {
                                let phoneNumber = val ?? '';

                                // Remove leading 0 if country code exists
                                if (!!dropdownValue && phoneNumber?.startsWith('0')) {
                                  phoneNumber = phoneNumber.slice(1);
                                }

                                setWitnessPhoneValue(phoneNumber);

                                if (phoneNumber) {
                                  const combinedValue = `${witnessDropdownValue} ${phoneNumber}`;
                                  setWitnessPhoneValue(phoneNumber === '' ? '' : phoneNumber);
                                  handleInputChange('witnessContact', combinedValue);

                                  if (REACT_APP_COUNTRY === 'ID') {
                                    setWitnessPhoneLength(
                                      !(phoneNumber.length > 0 && (phoneNumber.length < 8 || phoneNumber.length > 12)),
                                    );
                                  } else {
                                    setWitnessPhoneLength(
                                      !(phoneNumber.length > 0 && (phoneNumber.length < 8 || phoneNumber.length > 10)),
                                    );
                                  }
                                } else {
                                  setWitnessPhoneValue(''); // Reset phoneValue to empty if dropdownValue is not selected
                                  handleInputChange('witnessContact', ''); // Update the state accordingly
                                }
                              }}
                              maxLength={REACT_APP_COUNTRY === 'ID' ? 12 : 10}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className={styles['witness-video-verification-container']}>
                    <RadioButton
                      label={t('dashboard.join-team.register.input.videoVerification')}
                      checked={selectedOption === 'video'}
                      onChange={() => handleOptionChange('video')}
                    />
                    <Tooltip
                      message={t('dashboard.join-team.register.label.verificationWitnessMessage')}
                      preference={TooltipPreference.RIGHT}
                    />
                  </div>
                  <div className={styles['witness-subtext']}>
                    {t('dashboard.join-team.register.label.verificationWithoutWitnessMessage')}
                  </div>
                  {selectedOption === 'video' && (
                    <div className={styles['witness-video-container']}>
                      {videoPreview ? (
                        <div className={styles['witness-video-thumbnail-container']}>
                          <video controls className={styles['video-container']}>
                            <source src={videoPreview} type="video/mp4" />
                            {t('dashboard.join-team.register.label.browserDoNotSupportVideo')}
                          </video>
                          <button className={styles['video-clear-button']} onClick={clearVideo}>
                            {t('dashboard.join-team.register.button.removeVideo')}
                          </button>
                        </div>
                      ) : (
                        <div>
                          <div className={styles['witness-video-upload-container']}>
                            <VideoEditor
                              onFileUpload={handleVideoUpload}
                              accept="video/*"
                              fileTypeLabel={'Select MP4, MPEG, MOV, HEVC'}
                              dragCTALabel={t('dashboard.my-progress.dragAndDrop')}
                              connectorLabel={t('dashboard.my-progress.or')}
                              uploadCTALabel={t('dashboard.my-progress.selectFileToUpload')}
                              addAnotherFile={t('dashboard.my-progress.addAnotherFile')}
                            />
                          </div>
                          <div>
                            <span className={styles['label-red']}>*</span>
                            {t('dashboard.join-team.register.label.videoSize')}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              {/* </Accordion> */}
              <div className={styles['participant-register-button']}>
                <Button
                  buttonStyle={ButtonStyles.OUTLINE}
                  theme={Theme.GREEN}
                  title={t('dashboard.join-team.register.button.back')}
                  onClick={() => setShowNextForm(false)}
                />
                <Button
                  title={t('dashboard.join-team.register.button.register')}
                  buttonStyle={ButtonStyles.SOLID}
                  theme={Theme.GREEN}
                  disabled={
                    !(
                      check && // Must be checked
                      !participantSignatureEmpty && // Participant signature should not be empty
                      addParticipantData?.orderNumber && // Order number should not be empty
                      selectedOption && // An option must be selected
                      (campaignData?.configJson?.campaignIsHealthGoalSectionShown !== 1 || addParticipantData?.healthGoals?.length > 0) && // At least one health goal must be selected
                      ((selectedOption === 'witness' &&
                        !witnessSignatureEmpty &&
                        addParticipantData?.witnessName &&
                        addParticipantData?.witnessContact) || // If 'witness', signature, name, and contact must be provided
                        (selectedOption === 'video' && videoFile))
                    )
                  }
                  onClick={onSave}
                />
              </div>
            </>
          )}
        </div>
        {uploadImageModal}
        {showSucessModal && <SuccessModal data={{ name: campaignName }} onClose={handleCloseSuccessModal} />}
        {isOpenVerifyEmailDrawer && (
          <OTPModal
            email={userData?.email ?? ''}
            onClose={() => setIsOpenVerifyEmailDrawer(false)}
            onRequestOTP={handleRequestOTP}
            onVerifyOTP={handleVerifyEmail}
            countdown={countdown}
            startCountdown={startCountdown}
          />
        )}
      </div>
    </div>
  );
};
